import store_prestation from "@/store/mods/clinique/prestations"
import mod_prestation from "@/store/mods/clinique/prestations.js"

export default {
    name: 'm-chambre',
    components: {},
    props: {
        user_id: Number,
        info_patient: Object,
        info_caissier: Object,
        refresh_state: Number,
        is_proforma: Boolean,
        proforma_id: Number,
        can_add_differential_computing: Object,
        format_ref_facture: String,
        selected_slug: String,
        patient_insurance_info: Object
    },
    data() {
        return {
            one_is_checked: [],
            save_loading: false,
            choice_is_empty: false,
            is_error: false,
            permission_is_denied: false,

            filter_chambre: '',
            filtered_chambres: [],
            selected_prestations: [],

            tarif_chambres: [],
            is_loading: true,
            is_empty: false
        }
    },

    watch: {
        filter_chambre() {
            this.filterChambre()
        },

        one_is_checked() {
            this.choice_is_empty = false
        },

        refresh_state() {
            if (this.selected_slug == 'chambre') {
                this.fetchChambres()
            }
        }
    },

    computed: {
        
    },

    mounted() {
        
    },

    methods: {
        hadleUndefinedPrice() {
            this.warningToast("Le prix de cette chambre n'a pas été défini !")
        },

        fetchChambres() {
            this.is_loading = true
            const data = {
                assurance_id: 0,
                data_type: 'chambre'
            }
            store_prestation.getTarificationTypeAdmission(data).then((tarif_chambres) => {
                this.tarif_chambres = tarif_chambres
                this.filtered_chambres = this.tarif_chambres

                if (this.filtered_chambres.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }
                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.is_error = true
            })
        },

        submit() {
            if (this.one_is_checked.length == 0) {
                this.choice_is_empty = true
                return;
            }
            this.one_is_checked = this.setPrestationUID(this.one_is_checked)

            let data = {
                user_id: this.user_id,
                patient_id: this.info_patient.id,
                prestations: this.one_is_checked,
                type_prestation: 'Chambre',
                data_type: 'chambre',
                proforma_id: this.proforma_id,
                is_proforma: this.is_proforma,
                can_add_differential_computing: this.can_add_differential_computing.response,
                can_set_pac: this.can_set_pac,
                info_caissier: this.info_caissier,
                info_patient: {
                    nom_patient: this.info_patient.nom,
                    sexe: this.formatSexeMetier(this.info_patient.sexe),
                    telephone: this.info_patient.telephone_mobile,
                    num_dossier: this.info_patient.num_dossier,
                    age: this.info_patient.age
                },
                format_ref_facture: this.format_ref_facture
            }

            this.save_loading = true
            mod_prestation.getTarifPrestation(data).then((response) => {
                data = Object.assign(data, response)
                data.duree_forfait_hospi_est_expire = this.patient_insurance_info.duree_forfait_hospi_est_expire

                this.$store.dispatch('saveVentePrestation', data).then((response) => {
                    if (response.success) {
                        this.successToast('Ajout effectué avec succès')

                        this.$emit('emitPrestation', response.fpro_id)

                        this.one_is_checked = []
                        this.$refs.fpro_chambre.click()

                        if (response.fpro_id > 0) {
                            this.$router.push({ path: '/ventes/facture-proforma/'+response.fpro_id })
                        }
                    } else {
                        this.$refs.fpro_chambre.click()
                        this.dangerToast(response.message)
                    }

                    this.save_loading = false
                }).catch(() => {
                    this.save_loading = false
                    this.$refs.fpro_chambre.click()
                    this.dangerToast('Une erreur est survenue lors de l\'enregistrement. Veuillez réessayer plus tard.')
                })
            }).catch(() => {
                this.save_loading = false
                this.$refs.fpro_chambre.click()
                this.dangerToast('Une erreur est survenue lors du calcul des tarifs. Veuillez réessayer plus tard.')
            })
        },

        filterChambre() {
            this.filtered_chambres = [];

            if (this.filter_chambre == '') {
                this.filtered_chambres = this.tarif_chambres
            } else {
                this.tarif_chambres.forEach(chambre => {
                    let cleaned_chambre = this.removeAccents(chambre.nom_prestation)
                    let cleaned_filter = this.removeAccents(this.filter_chambre)

                    if (cleaned_chambre.toLowerCase().includes(cleaned_filter.toLowerCase())) {
                        this.filtered_chambres.push(chambre)
                    }
                });
            }
        },
    }
}
